import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(
	fetchBaseQuery({
		baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
	}),
	{ maxRetries }
);

export const messageAPI = createApi({
	reducerPath: "messageAPI",
	baseQuery,
	keepUnusedDataFor: 0,
	tagTypes: ["tagGetMessages"],
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		//* *********************************************************** */
		//* GET MESSAGE  */
		getMessages: builder.query({
			query: (body: any) => ({
				url: `/messages/?&page=${body.page}&limit=${body.limit}${body.searchAndFilterString}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetMessages"],
		}),
		//* *********************************************************** */
		//* POST MESSAGE  */
		postMessage: builder.mutation({
			query: (body: any) => ({
				url: `/messages/`,
				method: "post",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetMessages"],
		}),
		//* *********************************************************** */
		//* PUT MESSGE  */
		putMessage: builder.mutation({
			query: (body: any) => ({
				url: `/messages/${body.id}`,
				method: "put",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetMessages"],
		}),
		//* *********************************************************** */
		//* DELETE MESSAGE  */
		deleteMessage: builder.mutation({
			query: (body: any) => ({
				url: `/messages/${body.id}`,
				method: "delete",
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetMessages"],
		}),
		//* *********************************************************** */
	}),
});

export const { useGetMessagesQuery, usePostMessageMutation, usePutMessageMutation, useDeleteMessageMutation } =
	messageAPI;
